export default __webpack_public_path__ + "static/media/Aura-Egg__62.931554e6.png";